import React, { FC } from 'react';
import { TextV2 } from 'components/TextV2/TextV2';
import styles from './SelectionItem.module.scss';
import { ContentType } from 'api/contentful/contentTypes.cloverdotcom';
import { BYOItemPricing } from '../../BYOPricing/BYOItemPricing';

type SelectionItemProps = {
  label?: string;
  dcsIds: string[];
  quantity: number;
  contentType: ContentType;
  isSystemPreviewDrawer?: any;
};

export const SelectionItem: FC<SelectionItemProps> = ({
  label,
  dcsIds,
  quantity,
  contentType,
  isSystemPreviewDrawer,
}) => {
  if (!label || !dcsIds.length) return null;

  const itemLabel = quantity > 1 ? `${label} (${quantity})` : label;

  return (
    <div className={styles.selectionItemRow}>
      <TextV2 className={styles.label} value={itemLabel} variant="body-medium" />
      <div className={styles.pricingWrapper}>
        <BYOItemPricing
          dcsIds={dcsIds}
          quantity={quantity}
          contentType={contentType}
          isSystemPreviewDrawer={isSystemPreviewDrawer}
        />
      </div>
    </div>
  );
};
